import React from "react"
import PropTypes from 'prop-types'
import clearProps from '../../../utils/clearProps'

export default class Col extends React.Component {
  constructor(props) {
    super(props);

    this.renderCols = this.renderCols.bind(this)

  }

  getColsProperties(allProps){
    let colProps = []
    
    allProps.map((currentProp) => {
      let prefix = currentProp.match(/([a-z]{2})-(\d+)/);
      prefix = prefix ? prefix[1] : prefix
      
      let suffix = currentProp.match(/([a-z]{2})-(\d+)/);
      suffix = suffix ? suffix[2] : suffix
    
      
      if(prefix && suffix && prefix.match(/sm|md|lg|xs/) && !isNaN(Number(suffix))) {
        colProps.push(currentProp)
      }
      
    })

    return colProps;
  }
  
  renderCols(props){
    let className = ''

    props = props || {} // props always an object
    props = Object.keys(props) // getting object keys list [key, key, key] or []
    props = this.getColsProperties(props) // filtering props and getting only props of Col type

    props.map((prop) =>{
      className += `mdn-Col-${prop} `
    
    })

    return `${className} ${this.props.className || ''}`

  }

  render() {
    const { children, ...rest } = this.props
    const props = clearProps(this.props)
    return  <div {...props} className={this.renderCols(this.props)}>
        {children}
      </div>
  }
}

Col.propTypes = {
  children: PropTypes.node
}